<mat-dialog-content class="mat-typography">
    <h2>Ajout de photos</h2>
    <form class="grid grid-cols-1 gap-4 w-full px-8" [formGroup]="form" (ngSubmit)="onFormSubmit()">
        <mat-form-field>
            <mat-label>Pièce</mat-label>
            <mat-select matSelect formControlName="piece_id">
                <mat-option *ngFor="let piece of pieces" [value]="piece.id">
                    {{piece.nom_piece}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <div class="grid grid-cols-2 lg:grid-cols-4 xl:grid-cols-6 gap-4">
            <img [src]="photoToBeUploaded.url" *ngFor="let photoToBeUploaded of photosToBeUploaded"/>
            <label for="photo_lieu" [ngClass]="photosToBeUploaded.length > 0 ? '' : 'col-span-6'" class="flex photo-table-row text-center add-photo-row upload-row">
                <input class="mat-input-element input_file" id="photo_lieu" type="file" (change)="addFiles($event)" multiple />
                <div class="grow">
                    <div>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="h-6 w-6 inline-block"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            stroke-width="2"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
                            />
                        </svg>
                        Ajouter une photo des lieux
                    </div>
                </div>
            </label>
        </div>



    </form>
</mat-dialog-content>


<mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="undefined">Annuler</button>
    <button type="submit" mat-flat-button (click)="onFormSubmit()" [color]="'primary'">Téléverser</button>
</mat-dialog-actions>
